import "./PatientJourney.css";

const steps = [
  { num: "01", icon: "📋", title: "Book Appointment", desc: "Schedule online or call us. Pick your preferred date and time." },
  { num: "02", icon: "💬", title: "Consultation", desc: "Meet the doctor, discuss your concerns, and get a full examination." },
  { num: "03", icon: "🔍", title: "Diagnosis", desc: "Advanced imaging and assessment to understand your dental needs." },
  { num: "04", icon: "💊", title: "Treatment", desc: "Personalised treatment performed with precision and comfort." },
  { num: "05", icon: "✅", title: "Follow-up Care", desc: "Post-treatment support and regular check-ins for lasting results." },
];

export default function PatientJourney() {
  return (
    <section className="journey">
      <div className="journey-inner">
        <div className="journey-header">
          <span className="section-tag">How It Works</span>
          <h2 className="section-title">Your Patient Journey</h2>
          <p className="section-subtitle">
            We make your dental experience simple, transparent, and comfortable — from your very first call to your final smile.
          </p>
        </div>

        <div className="journey-steps">
          {steps.map((s, i) => (
            <div key={s.num} className="journey-step">
              <div className="step-connector">
                {i < steps.length - 1 && <div className="connector-line"></div>}
              </div>
              <div className="step-circle">
                <span className="step-icon">{s.icon}</span>
              </div>
              <div className="step-content">
                <span className="step-num">{s.num}</span>
                <h3 className="step-title">{s.title}</h3>
                <p className="step-desc">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}